// import { allapiAction } from "@/Redux/common/action";
// import { URL } from "@/Redux/common/url";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { toast } from "react-toastify";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import { LazyLoadImage } from "react-lazy-load-image-component";
import LodingImg from "./LodingImg";
// import { allapiAction } from "../../Redux/common/action";

function AppSlider({ sliderdate }) {
  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    centerMode: true,
    centerPadding: "15px",
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  const dispatch = useDispatch();
  // createSubscription

  const [Subscr, setSubscr] = useState("");

  // const slider_list = sliderdate;
  const slider_list = useSelector((state) =>
    state?.allapi?.slider_list ? state?.allapi?.slider_list : {}
  );
  const ssi = [
    { image: "./assets/imgs/a1.avif" },
    { image: "./assets/imgs/a2.avif" },
    { image: "./assets/imgs/a6.avif" },
  ];

  const hendleSubscrition = (event) => {
    event.preventDefault();
    if (!Subscr) {
      toast.error("Please enter your email");
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(Subscr)) {
      toast.error("invalid email");
    } else {
      dispatch(allapiAction.createSubscription({ email: Subscr }));
      setSubscr("");
      return () => {};
    }
  };

  useEffect(() => {
    // slider_list

    dispatch(allapiAction.getsliderList({ forslider: "app" }));
    return () => {};
  }, []);

  // console.log(sliderdate);
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <div>
      <section className="home-slider position-relative mb-5">
        <div className="">
          <div className="home-slide-cover ">
            <div
              className="homePageSlider1 appslider"
              data-aos="fade-top"
              data-aos-delay={"100"}
            >
              <Slider {...settings}>
                {slider_list?.sliders &&
                  slider_list?.sliders?.map((data, i) => {
                    return (
                      <div
                        key={i}
                        className="single-hero-slider single-animation-wrap homePageSlidernewapp "
                        // style={{
                        //   backgroundImage:
                        //     "url(/assets/imgs/slider/banner-0.jpg)",
                        // }}
                      >
                        {/* <img src={data?.image} alt={"slider" + i} /> */}

                        <LodingImg i={i} data={data} />
                        
                      </div>
                    );
                  })}

                
              </Slider>
            </div>

            <div className="slider-arrow hero-slider-1-arrow"></div>
          </div>
        </div>
      </section>
      {/* <div
        style={{
          backgroundImage: `url("./assets/imgs/slider/slider-1.png")`,
        }}
      ></div> */}
    </div>
  );
}

export default AppSlider;
